
  module.exports =
  {

    _init: function ()
    {

      this.onChangeCompany()

      this.onSubmit()

    },

    onChangeCompany: function ()
    {

      $('#company_id').not('.js-ignore').change(function ()
      {

        var company_id = $(this).val()

        var phase = $('#phase_id')

        APPLICATION._APPLICATION.loadDropdown(
          phase,
          APPLICATION._PATH_PREFIX + 'company/phases/' + company_id + '?phase_id=' + phase.val() + '&no_completed=1',
          'Company',
          'phases'
        )

      }
      ).addClass('js-ignore').trigger('change')

    },

    onSubmit: function ()
    {

      $('.js-download').not('.js-download-ignore').click(function ()
      {
        $('.js-error').remove()
      }
      ).addClass('js-download-ignore')
 
    }
 
  }